package com.dignicate.web.ui.components.layout

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.dignicate.web.css.height
import com.dignicate.web.domain.FooterNav
import com.dignicate.web.ui.components.footer.Footer
import com.dignicate.web.ui.components.header.Header
import com.dignicate.web.ui.components.header.SettingsDialog
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLButtonElement

@Composable
fun PageLayout(
    footerNav: FooterNav?,
    navigate: (String) -> Unit,
    onOpenSettings: () -> Unit,
    content: @Composable () -> Unit
) {
    var settingsOpen by remember { mutableStateOf(false) }

    Header(
        navigate = navigate,
        onOpenSettings = { settingsOpen = true },
    )

    Div({ classes("site-root") }) {
        Div({ style { height(120.px) } }) { }
        Div({ classes("site-content") }) {
            content()
        }

        footerNav?.let {
            Footer(
                nav = it,
                onNavigate = navigate
            )
        }
    }

    SettingsDialog(
        isOpen = settingsOpen,
        onClose = {
            settingsOpen = false
            window.setTimeout({
                val el = document.getElementById("gear-button") as? HTMLButtonElement
                el?.focus()
            }, 0)
        }
    )
}
